import useAuthStore from '~/stores/auth';
import { defineNuxtPlugin, useRuntimeConfig } from '#app';
import useInteractiveContentStore from '~/stores/interactiveContent';
import useLmsStore from '~/lms';
import useBillingStore from '~/stores/billing';
import useBundleStore from '~/stores/bundles';
import useMagazineStore from '~/stores/magazine';
import useBlogStore from '~/stores/blog';

function injectStoreConfig(store: any, config: Record<string, any>) {
   for (const key in config) {
      if (key in store) {
         store[key] = config[key];
      }
   }
}

export default defineNuxtPlugin(() => {
   const config = useRuntimeConfig();

   const commonStoreValues = {
      domain: config.public.siteDomain,
      lmsApiBaseurl: config.public.lmsApiBaseurl,
   };

   const authStore = useAuthStore();
   injectStoreConfig(authStore, commonStoreValues);

   const interactiveContentStore = useInteractiveContentStore();
   injectStoreConfig(interactiveContentStore, commonStoreValues);

   const lmsStore = useLmsStore();
   injectStoreConfig(lmsStore, commonStoreValues);

   const billingStore = useBillingStore();
   injectStoreConfig(billingStore, commonStoreValues);

   const bundleStore = useBundleStore();
   injectStoreConfig(bundleStore, commonStoreValues);

   const magazineStore = useMagazineStore();
   injectStoreConfig(magazineStore, commonStoreValues);

   const blogStore = useBlogStore();
   injectStoreConfig(blogStore, commonStoreValues);
   // Initialize other stores here if needed
});
